import Loading from "../../../../../../components/Loading";
import TicketsAutoList from "../../../../../../components/TicketsAutoList ";
import useTickets from "./useTickets";


export default function Tickets() {

    const {
        isLoading,
        ticketsAuto,
        loadMore,
        hasMore
    } = useTickets();

    return (
        <Loading loading={isLoading} >
            <TicketsAutoList
                paginated
                tickets={ticketsAuto}
                loadMore={loadMore}
                hasMore={hasMore}
                isLoading={isLoading}
                emptyListMessage="Não há bilhetes concorrendo neste sorteio"
            />
        </Loading >
    )
}
